<template>
    <div class="card mb-0 shadow">
        <div class="card-body">
            <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                    <!-- <div class="row">
                        <div class="col-12 px-2">
                            <h4 class="font-weight-bold">
                                Termo de Compromisso
                            </h4>
                        </div>
                    </div> -->
                    <load
                        mode="table"
                        message="Carregando termo de compromisso"
                        v-if="loading"
                    />
                    <div class="row px-2 border mb-3" v-else>
                        <div id="boxPrint" class="col-12 mb-3" contenteditable>
                            <print-header
                                class="d-flex justify-content-center"
                            />
                            <div id="boxContent" v-html="text_edit"></div>
                            <!-- <editor
								apiKey="xmvncqtu4n5y7d1xpaa2l21cl207m7ggc6zljyk7emudl10c"
								v-model="text_edit"
								ref="termoTextarea"
								:init="init"
							/> -->
                        </div>
                        <!-- <textarea id="summernote" name="editordata"></textarea> -->
                        <!-- <form-textarea-editor ref="termoTextarea" v-model="text_edit" /> -->
                    </div>
                    <!-- <div style="display: none" class="row">
                        <div class="col-12" id="boxPrint">
                            <print-header />
                            <div v-html="text_edit"></div>
                        </div>
                    </div> -->
                    <div
                        class="row px-0 d-flex justify-content-end"
                        v-if="loading == false"
                    >
                        <button
                            class="btn btn-primary"
                            :title="$t('Visualizar e Imprimir')"
                            @click="print"
                        >
                            <i class="mdi mdi-printer mdi-18px" />
                        </button>
                        <b-button class="btn btn-default" @click="redefinir">
                            <i class="mdi mdi-autorenew mdi-18px" />
                        </b-button>
                        <button
                            class="btn btn-success btn-submit"
                            data-style="zoom-in"
                            type="submit"
                            @click="submit"
                        >
                            <i class="mdi mdi-content-save" />
                            {{ $t("Salvar") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Editor from "@tinymce/tinymce-vue";
export default {
    props: ["item"],
    components: {
        editor: Editor,
    },
    data() {
        return {
            observacoes: "",
            app_cidade: this.$store.state.settings.app_cidade,
            loading: true,
            text_edit: "",
            text_default:
                '<h2 style="text-align: center;">Termo de Compromisso</h2>\n<p style="text-align: justify;">Eu, <strong><span id="socioeducando">______________________________________</span> </strong>, declaro ter sido devidamente orientado (a) sobre as <br />responsabilidades no cumprimento do Plano de Objetivos e Metas a mim estabelecido, comprometendo-me a:</p>\n<p>I. comparecer aos Atendimentos;&nbsp;<br />II. participar dos grupos, servi&ccedil;os e programas sugeridos pela equipe t&eacute;cnica;&nbsp;<br />III. comprometimento com os objetivos e metas estabelecidos;<br /> ____________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________</p>\n<p style="text-align: justify;">Eu, <span id="responsavel">____________________________________________</span>, enquanto respons&aacute;vel pela crian&ccedil;a ou adolescente supracitado, <br />comprometo-me a colaborar no cumprimento dos objetivos e metas estabelecidos neste plano individual de Atendimento (PIA).</p>\n<p>&nbsp;</p>\n<p style="float: right;"><span id="cidade">São Paulo</span>,<span id="data">_____ de ________________ de 2021</span><br /><br /></p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p><strong>Observa&ccedil;&otilde;es Gerais:</strong></p>\n<p>___________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________</p>\n<p><strong>ASSINATURAS DE COMPROMISSO:</strong></p>\n<p>&nbsp;</p>\n<p style="text-align: center;">___________________________________________________________________</p>\n<p style="text-align: center;"><strong>USU&Aacute;RIO</strong></p>\n<p>&nbsp;</p>\n<p style="text-align: center;">___________________________________________________________________</p>\n<p style="text-align: center;"><strong>RESPONS&Aacute;VEL</strong></p>\n<p>&nbsp;</p>\n<p style="text-align: center;">___________________________________________________________________</p>\n<p style="text-align: center;"><strong>T&Eacute;CNICO DE REFER&Ecirc;NCIA DO SERVI&Ccedil;O DE ACOLHIMENTO</strong></p>\n<p style="text-align: center;">&nbsp;</p>',
            init: {
                height: 500,
                menubar: false,
                plugins: [
                    "advlist autolink lists link image charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code help wordcount",
                ],
                toolbar:
                    "undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help",
            },
        };
    },
    mounted() {
        this.getTermo();
    },
    methods: {
        submit() {
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            if (ladda) {
                ladda.start();
            }
            let texto = document.getElementById("boxContent");
            axios
                .post(`api/dashboard/acolhimento/storetermo`, {
                    acolhimento_id: this.item.id,
                    texto: texto.innerHTML,
                })
                .then((response) => {
                    ladda.stop();
                    this.$snack.success({
                        button: false,
                        text: "Termo cadastrado com sucesso.",
                    });
                })
                .finally(() => {
                    this.progressCompleted = 0;
                    this.files = [];
                });
        },
        getTermo() {
            this.loading = true;
            axios
                .get(`api/dashboard/acolhimento/get/termo/${this.item.id}`)
                .then((response) => {
                    this.loading = false;
                    if (response.data.texto) {
                        this.text_edit = response.data.texto;
                    } else {
                        this.text_edit = this.changeText(this.text_default);
                    }
                });
        },
        redefinir() {
            document.getElementById("boxContent").innerHTML = this.changeText(
                this.text_default
            );
        },
        changeText(string) {
            if (string) {
                string = string.replace(
                    `<span id="socioeducando">______________________________________</span>`,
                    `<b>${this.item.nome_acolhido}</b>`
                );
                string = string.replace(
                    `<span id="cidade">São Paulo</span>`,
                    this.app_cidade
                );
                string = string.replace(
                    `<span id="data">_____ de ________________ de 2021</span>`,
                    moment().format("LL")
                );
            }
            this.loading = false;

            return string;
        },
        print() {
            const modal = document.getElementById("boxPrint");
            const cloned = modal.cloneNode(true);
            let section = document.getElementById("print");

            if (!section) {
                section = document.createElement("div");
                section.id = "print";
                document.body.appendChild(section);
            }

            section.innerHTML = "";
            section.appendChild(cloned);
            window.print();
        },
    },
};
</script>
<style lang="css">
.tox-statusbar {
    display: none !important;
}
</style>
